module.exports = __webpack_public_path__ + "static/img/avartar.1159120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avartar.png
// module id = c1PY
// module chunks = 0